import { getObjectKeysAsObject } from "@hopper-b2b/checkout";
import { checkAuthStatusService } from "./checkAuthStatus";
import { fetchPaymentMethodsService } from "./fetchPaymentMethods";
import { notifyFailedEnrollment } from "./notifyFailedEnrollment";
import { notifySuccessfulEnrollment } from "./notifySuccessfulEnrollment";
import { trackViewPayment } from "./trackViewPayment";

export const NubankPaymentServices = {
  checkAuthStatusService,
  fetchPaymentMethodsService,
  notifyFailedEnrollment,
  notifySuccessfulEnrollment,
  trackViewPayment,
};

export const NubankPaymentServiceTypes = getObjectKeysAsObject(
  NubankPaymentServices
);
